'use strict';

module.exports = ['$scope', '$rootScope', '$http', '$interval', '$timeout', '$uibModal', 'moment', '$auth', function($scope, $rootScope, $http, $interval, $timeout, $uibModal, moment, $auth) {
	$scope.people = [];
	$scope.token = null;
	$scope.newName = "";
	$scope.pendingOrderChange = null;

	var now = moment.utc();
	$scope.diff = now - moment.unix(jsonPreload.now);

	$scope.$on('loginChanged', function() {
		$scope.token = $rootScope.token;

		if ($scope.token) {
			//var encodedPayload = $scope.token.split('.')[1];
			var payload = $auth.getPayload(); //JSON.parse(atob(encodedPayload));
			$scope.admin = payload.admin;

			if ($scope.admin) {
				$http({
					method: "GET",
					url: "api/people/"
				}).then(function success(response) {
					response.data.forEach(function (item) {
						//$scope.people[item.id] = item;
						item.lastSeen = item.lastSeen ? moment(moment.unix(item.lastSeen) + $scope.diff) : null;
					});
					$scope.people = response.data;
				}, function failure(response) {

				});
			}
		} else {
			delete $scope.admin;
		}
	});

	$scope.dragControlOptions = {
		orderChanged: function(event) {
			if ($scope.pendingOrderChange != null) {
				$timeout.cancel($scope.pendingOrderChange);
			}

			$scope.pendingOrderChange = $timeout(function () {
				$scope.pendingOrderChange = null;

				var ids = $scope.people.map(function (item) { return item.id });

				$http({
					method: "PUT",
					url: "api/people/sequence",
					data: ids
				}).catch(function failure(response) {
			    	console.log("Failed to put sequence.", ids, response);
					var childScope = $scope.$new();
					childScope.title = "Whoops?";
					childScope.body = "There was an error saving the sequence order.";
					$uibModal.open({
						templateUrl: 'genericok.html',
						scope: childScope
					});
			   	});

			}, 5000);
		},
		additionalPlaceholderClass: 'row'
	};

	$scope.isPresent = function(person) {
		if (person.owner) {
			return true;
		}

		if (!person.lastSeen) {
			return false;
		}
		
		var diff = moment.utc().diff(person.lastSeen, 'hours', true);
		if (diff < 2.0) {
			return true;
		} else {
			return false;
		}
	};

	$scope.addPerson = function() {
		var newPerson = {
			name: $scope.newName
		};

		$http({
			method: "POST",
			url: "api/people/",
			data: newPerson
		}).then(function success(response) {
			$scope.people.push(response.data);
		}, function failure(response) {
	    	console.log("Failed to add person.", newPerson, response);
			var childScope = $scope.$new();
			childScope.title = "Whoops?";
			childScope.body = "There was an error adding that person.";
			$uibModal.open({
				templateUrl: 'genericok.html',
				scope: childScope
			});
	   	});

		$scope.newName = "";
	};

	$scope.deletePerson = function(person, really) {
		if (!really) {
			if (person.confirmDelete) {
				person.confirmDelete = false;
				$timeout.cancel(person.confirmPromise);
				person.confirmPromise = null;
			} else {
				person.confirmDelete = true;
				person.confirmPromise = $timeout(function () {
					person.confirmDelete = false;
					person.confirmPromise = null;
				}, 10000);
			}
		} else if (person.id) {
			$http({
				method: "DELETE",
				url: "api/people/" + person.id
			}).then(function success(response) {
				// Remove from the person list
				var idx = $scope.people.indexOf(person);
				if (idx >= 0) {
				    $scope.people.splice(idx, 1);
				}
			}, function failure(response) {
				console.log("Failed to delete person.", person, response);
				var childScope = $scope.$new();
				childScope.title = "Whoops?";
				childScope.body = "There was an error deleting that person.";
				$uibModal.open({
					templateUrl: 'genericok.html',
					scope: childScope
				});
		   	});
		}
	};

	$scope.zapPerson = function(person, really) {
		if (!really) {
			if (person.confirmZap) {
				person.confirmZap = false;
				$timeout.cancel(person.confirmZapPromise);
				person.confirmZapPromise = null;
			} else {
				person.confirmZap = true;
				person.confirmZapPromise = $timeout(function () {
					person.confirmZap = false;
					person.confirmZapPromise = null;
				}, 10000);
			}
		} else if (person.id) {
			person.confirmZap = false;
			$timeout.cancel(person.confirmZapPromise);
			person.confirmZapPromise = null;

			$http({
				method: "DELETE",
				url: "api/people/claim/" + person.id
			}).then(function success(response) {
				// Clear lastSeen
				person.lastSeen = null;
				person.owner = null;
			}, function failure(response) {
				console.log("Failed to zap person.", person, response);
				var childScope = $scope.$new();
				childScope.title = "Whoops?";
				childScope.body = "There was an error zapping that person.";
				$uibModal.open({
					templateUrl: 'genericok.html',
					scope: childScope
				});
		   	});
		}
	};

	$scope.updatePerson = function(person) {
		if (person.dirty) {
			$http({
				method: "PUT",
				url: "api/people/" + person.id,
				data: {
					id: person.id,
					name: person.name
				}
			}).then(function success(response) {
				delete person.dirty;
			}, function failure(response) {
				console.log(response);
				person.error = response.statusText;
			});
		}
	};
}];
